import type { EntityAction } from "@firecms/core";
import { ContentCopyIcon } from "@firecms/ui";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import type { Space } from "../collections/spaces";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import { tableOnlyEntityAction } from "./entityActionDefaults";
import { openConfirmTextAction } from "./openConfirmTextAction";

export function buildCloneSpaceEntityAction(
  accountId: string
): EntityAction<Space> {
  const t = getAdminT(getAdminUiLocale());

  return {
    key: "clone-space",
    name: t("cloneSpace.entityAction"),
    icon: <ContentCopyIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: ({ entity, context }) => {
      if (!entity) {
        return;
      }

      openConfirmTextAction(context, {
        key: `clone-space-${entity.id}`,
        title: t("cloneSpace.title"),
        body: t("cloneSpace.body"),
        onConfirm: async () => {
          try {
            const functions = getFunctions(getApp());
            const callable = httpsCallable(functions, "cloneSpace");
            await callable({ accountId, spaceId: entity.id });
            context.snackbarController.open({
              type: "success",
              message: t("cloneSpace.success"),
            });
            return true;
          } catch (error: unknown) {
            const message =
              error instanceof Error
                ? error.message
                : t("common.unknownError");
            context.snackbarController.open({
              type: "error",
              message: t("cloneSpace.error", { message }),
            });
            console.error(error);
            return false;
          }
        },
      });
    },
  };
}
